import { useEffect, useState } from 'react';

import { TToast } from 'src/store';

import styles from './ToastItem.module.scss';


type TProps = {
	index: number;
	item: TToast;
};

export function ToastItem(props: TProps) {
	const {
		index,
		item,
	} = props;

	const { text, isActive: isActiveRaw } = item;

	console.log('index', index);

	const [isActive, setIsActive] = useState(isActiveRaw);

	useEffect(() => {
		if (isActive !== isActiveRaw) {
			setIsActive(isActiveRaw);
		}
	}, [isActive]);



	// const onClick = () => {
	// 	if (classNames.includes(styles.active)) {
	// 		const value = classNames.filter(item => item !== styles.active);

	// 		setClassNames(value);
	// 	} else {
	// 		setClassNames([...classNames, styles.active]);
	// 	}
	// };

	const classNames = [];

	if (isActive) {
		classNames.push(styles.active);
	}

	return (
		<div
			className={ classNames.join(' ') }
			// onClick={ e => onClick() }
		>
			{ text }
		</div>
	);
}
